const WEBSITE_TOKEN_KEY = "website_auth_token";
const WEBSITE_PENDING_ACTION_KEY = "website_pending_action";

const setWebsiteToken = (token) => {
  localStorage.setItem(WEBSITE_TOKEN_KEY, token);
};

const getWebsiteToken = () => {
  return localStorage.getItem(WEBSITE_TOKEN_KEY);
};

const clearWebsiteToken = () => {
  localStorage.removeItem(WEBSITE_TOKEN_KEY);
};

const getoptionalAppAuthHeaders = () => {
  const token = getWebsiteToken();
  if (!token) return {};
  return { Authorization: `Bearer ${token}` };
};

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (!payload?.exp) return true;
    const now = Math.floor(Date.now() / 1000);
    return payload.exp <= now;
  } catch (error) {
    return true;
  }
};

const isWebsiteLoggedIn = () => {
  const token = getWebsiteToken();
  if (!token) return false;
  return !isTokenExpired(token);
};

const setPendingWebsiteAction = (action) => {
  localStorage.setItem(WEBSITE_PENDING_ACTION_KEY, JSON.stringify(action || {}));
};

const getPendingWebsiteAction = () => {
  try {
    const raw = localStorage.getItem(WEBSITE_PENDING_ACTION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
};

const clearPendingWebsiteAction = () => {
  localStorage.removeItem(WEBSITE_PENDING_ACTION_KEY);
};

const consumePendingWebsiteAction = () => {
  const action = getPendingWebsiteAction();
  clearPendingWebsiteAction();
  return action;
};

const getWebsiteUserId = () => {
  const token = getWebsiteToken();
  if (!token) return null;
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    return payload?.userId || payload?.id || payload?._id || null;
  } catch (error) {
    console.error("Failed to decode token:", error);
    return null;
  }
};

export {
  WEBSITE_TOKEN_KEY,
  setWebsiteToken,
  getWebsiteToken,
  getoptionalAppAuthHeaders,
  clearWebsiteToken,
  isWebsiteLoggedIn,
  setPendingWebsiteAction,
  getPendingWebsiteAction,
  clearPendingWebsiteAction,
  consumePendingWebsiteAction,
  getWebsiteUserId
};
